import styled from 'styled-components';

export const ContainButton = styled.div`
  display: flex;
  margin-top: 18px;
  margin-left: 10px;
`;

export const ContainerInput = styled.div`
  width: ${props => props.width || '30%'};
  margin: 0 15px;
`;
